import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export const useAutoFillRules = () => {
  return useQuery({
    queryKey: ['autoFillRules'],
    queryFn: async () => {
      const response = await api.get('/api-integrations/auto-fill-rules');
      return response.data;
    },
  });
};

export const useAutoFillRuleById = (id: string) => {
  return useQuery({
    queryKey: ['autoFillRule', id],
    queryFn: async () => {
      const response = await api.get(`/api-integrations/auto-fill-rules/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
};

export const useCreateAutoFillRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: any) => {
      const response = await api.post('/api-integrations/auto-fill-rules', payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['autoFillRules'] });
    },
  });
};

export const useUpdateAutoFillRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: any }) => {
      const response = await api.put(`/api-integrations/auto-fill-rules/${id}`, payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['autoFillRules'] });
    },
  });
};

export const useDeleteAutoFillRule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete(`/api-integrations/auto-fill-rules/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['autoFillRules'] });
    },
  });
};

export const executeAutoFillRule = async (documentTypeId: string, documentName: string) => {
  const response = await api.get(`/api-integrations/auto-fill/${documentTypeId}?name=${encodeURIComponent(documentName)}`);
  return response.data;
};
